
export const ICONOS_BOTON = {
    RESULTADOS: 'ICONO_RESULTADOS',
    EDITAR: 'ICONO_EDITAR',
    ENCUESTAENABLED: 'ENCUESTAENABLED',
    ENCUESTADISABLED: 'ENCUESTADISABLED',
    EXPORTAR: 'EXPORTAR',
};